// SSE 연결

import { nestPath } from "../landRegister/axoisPath";
import { useEffect, useRef, useState } from "react";
import { useUserInfo } from "../user/userApi";
import { CompleteRequestStatus } from "./chat";
import { useQueryClient } from "react-query";

// 전문가매칭용
const path = {
    sseMatch: `${nestPath}/sse/match/user`,
    sseDisconnect: `${nestPath}/sse/disconnect`,
};

const 완료요청상태업데이트 = "COMPLETE_REQUEST_UPDATE";
const 매칭수락 = "ACCEPT_MATCH_REQUEST";
const 완료요청거절 = "DENY_COMPLETION_REQUEST"; //[전문가]
const 지원취소 = "TAKER_CANCEL_MATCH_REQUEST"; //[의뢰인]

const useSSEMatch = () => {
    const queryClinet = useQueryClient();

    const [completeRequestStatus, setCompleteRequestStatus] = useState<CompleteRequestStatus>(CompleteRequestStatus["진행중"]);
    const [matchAcceptedAt, setMatchAcceptedAt] = useState<number | null>(null);
    const [denyCompleteMatchRequestAt, setDenyCompleteMatchRequestAt] = useState<number | null>(null);
    const [takerCancelMatchRequestAt, setTakerCancelMatchRequestAt] = useState<number | null>(null);

    const { data: userInfo } = useUserInfo(true);
    const userNo = userInfo?.user_no;
    useEffect(() => {
        if (!userNo) return;

        const es = new EventSource(`${path.sseMatch}?userNo=${userNo}`);

        if (userNo) {
            es.onopen = () => {
                console.log("SSE 연결 성공");
            };

            es.onmessage = (event) => {
                try {
                    queryClinet.invalidateQueries({ queryKey: ["chattingRoomInfo"] });
                    const payload = JSON.parse(event.data);

                    if (payload?.types?.includes(완료요청상태업데이트)) {
                        setCompleteRequestStatus(payload.data.completeRequestStatus as CompleteRequestStatus);
                    }

                    if (payload?.types?.includes(매칭수락)) {
                        setMatchAcceptedAt(Date.now());
                    }
                    if (payload?.types?.includes(완료요청거절)) {
                        setDenyCompleteMatchRequestAt(Date.now());
                    }
                    if (payload?.types?.includes(지원취소)) {
                        setTakerCancelMatchRequestAt(Date.now());
                    }
                } catch {
                    console.warn("SSE message parse error:", event.data);
                }
            };

            es.onerror = (event) => {
                console.log("SSE 연결 오류", event);
            };
        }

        return () => {
            if (es) {
                es.close();
            }
        };
    }, [userNo]);

    return { completeRequestStatus, matchAcceptedAt, denyCompleteMatchRequestAt, takerCancelMatchRequestAt };
};

export default useSSEMatch;
